import { useSelector, useDispatch } from 'react-redux';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Alert,
    alpha
} from '@mui/material';
import { Delete as DeleteIcon, Close as CloseIcon, Warning as WarningIcon } from '@mui/icons-material';

import * as actions from '../redux.actions';
import * as selectors from '../redux.selectors';

const DeleteConfirmationDialog = () => {
    const dispatch = useDispatch();

    // Redux state
    const isOpen = useSelector(selectors.isDeleteDialogOpenSelector);
    const selectedGoal = useSelector(selectors.selectedGoalSelector);
    const loading = useSelector(selectors.loadingSelector);

    const handleClose = () => {
        dispatch(actions.closeDeleteDialog());
    };

    const handleConfirm = () => {
        if (selectedGoal) {
            dispatch(actions.deleteGoal(selectedGoal.id));
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningIcon color="error" />
                Confirm Delete
            </DialogTitle>

            <DialogContent dividers>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    This action cannot be undone. The goal will be permanently deleted.
                </Alert>

                {selectedGoal && (
                    <Box>
                        <Typography variant="body1" gutterBottom>
                            Are you sure you want to delete this goal?
                        </Typography>
                        <Box sx={(theme) => ({ mt: 2, p: 2, bgcolor: alpha(theme.palette.divider, 0.06), borderRadius: 1 })}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Goal Details:
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 1 }}>
                                <strong>Name:</strong> {selectedGoal.name || 'Unknown'}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                <strong>Description:</strong> {typeof selectedGoal.description === 'string' ? selectedGoal.description : 'No description'}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                <strong>Complexity:</strong> {selectedGoal.complexity?.toUpperCase() || 'N/A'}
                            </Typography>
                        </Box>
                    </Box>
                )}
            </DialogContent>

            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button
                    onClick={handleClose}
                    startIcon={<CloseIcon />}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="error"
                    startIcon={<DeleteIcon />}
                    disabled={loading}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
